<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <div class="mb-10" v-if="model.id == null">
        <div class="border-1 w-full border border-solid rounded-lg p-5">
          <h5>{{ $t("Payer") }}</h5>
          <div class="mt-5">
            <label class="vs-select--label">{{ $t("Account") }}</label>
            <v-select
              label="name"
              :options="listOfAccountPayer"
              name="account"
              v-model="model.payerAccount"
              @input="onlistOfAccountPayerSelected"
              :clearable="false"
              dir="rtl"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('account')">{{
              errors.first("account")
            }}</span>
          </div>
          <div class="mt-5">
            <label class="vs-select--label">{{ $t("AccountFloating") }}</label>
            <v-select
              label="name"
              :options="listOfFloatingAccountPayer"
              name="floatingAccount"
              v-model="model.payerFloatingAccount"
              :clearable="false"
              dir="rtl"
            >
            </v-select>
          </div>
        </div>
        <div class="border-1 w-full border border-solid rounded-lg p-5 mt-5">
          <h5>{{ $t("Receiver") }}</h5>
          <div class="mt-5">
            <label class="vs-select--label">{{ $t("Account") }}</label>
            <v-select
              label="name"
              :options="listOfAccount"
              name="account"
              v-model="model.receiverAccount"
              @input="onlistOfAccountSelected"
              :clearable="false"
              dir="rtl"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('account')">{{
              errors.first("account")
            }}</span>
          </div>
          <div class="mt-5">
            <label class="vs-select--label">{{ $t("AccountFloating") }}</label>
            <v-select
              label="name"
              :options="listOfFloatingAccount"
              name="floatingAccount"
              v-model="model.receiverFloatingAccount"
              :clearable="false"
              dir="rtl"
            >
            </v-select>
          </div>
        </div>
        <div>
          <vs-input
            class="inputx mb-4 mt-5"
            v-model="model.amount"
            name="Amount"
            :label="$t('Amount')"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('Amount')">{{
            errors.first("Amount")
          }}</span>
        </div>
        <div>
          <label class="vs-select--label datepicker-lb">{{
            $t("CreateOn")
          }}</label>
          <date-picker
            v-model="model.createOn"
            type="datetime"
            format="jYYYY-jMM-jDD HH:mm:ss"
            v-validate="'required'"
            display-format="jYYYY-jMM-jDD HH:mm:ss"
            id="date-picker"
            :label="$t('CreateOn')"
            name="date"
          />
          <span class="text-danger text-sm" v-show="errors.has('CreateOn')">{{
            errors.first("CreateOn")
          }}</span>
        </div>
        <div>
          <vs-textarea
            rows="3"
            class="mt-4"
            name="Description"
            :label="$t('Description')"
            v-validate="'required'"
            v-model="model.description"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('Description')"
            >{{ errors.first("Description") }}</span
          >
        </div>
      </div>

      <vs-button
        type="filled"
        class="float-right mb-4"
        :class="model.id != null ? 'mt-12' : ''"
        @click.prevent="submitForm"
        :disabled="
          !model.description ||
          !model.createOn ||
          !model.amount ||
          !model.payerAccount ||
          !model.receiverAccount
        "
        >{{ $t("Save") }}</vs-button
      >
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "@/components/CustomVSelect.vue";

const dict = {
  custom: {
    CreateOn: {
      required: "لطفا تاریخ درج را وارد نمایید.",
    },
    account: {
      required: "لطفا  حساب را وارد نمایید.",
    },
    Amount: {
      required: "لطفا  مقدار را وارد نمایید.",
    },
    Description: {
      required: "لطفا  توضیحات را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  components: {
    "v-select": vSelect,
  },
  props: {
    show: { default: false },

    parentId: 0,
    parentCode: "",

    products: null,
  },
  data() {
    return {
      listOfAccount: [],
      listOfAccountPayer: [],
      listOfFloatingAccount: [],
      listOfFloatingAccountPayer: [],
      model: {},
      AccountTitle: "",
      popupTitle: "",
      accountName: "",
      disabled: false,
    };
  },
  computed: {
    showModal: {
      get: function () {
        this.GetData();
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },

  methods: {
    ...mapActions({
      fetchAccounts: "pettyCash/getAllLastLevelOfAccounts",
      fetchFloatingAccounts: "pettyCash/getAllLastLevelOfFloatingAccounts",
      createAccount: "pettyCash/savePayment",
    }),
    GetData() {
      this.fetchAccounts().then((result) => {
        this.listOfAccount = result;
        this.listOfAccountPayer = result;
      });
    },

    onlistOfAccountSelected() {
      this.fetchFloatingAccounts(this.model.receiverAccount.id).then(
        (result) => {
          result.forEach((element) => {
            var x = {
              id: element.id,
              name: element.title,
              code: element.code,
            };
            this.listOfFloatingAccount.push(x);
          });
        }
      );
    },
    onlistOfAccountPayerSelected() {
      this.fetchFloatingAccounts(this.model.payerAccount.id).then((result) => {
        result.forEach((element) => {
          var x = {
            id: element.id,
            name: element.title,
            code: element.code,
          };
          this.listOfFloatingAccountPayer.push(x);
        });
      });
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        this.disabled = true;
        if (result) {
          var payload = {
            amount: this.model.amount,
            createOn: this.model.createOn,
            description: this.model.description,
            payerInfo: {
              accountCode: this.model.payerAccount.code,
              accountName: this.model.payerAccount.name,
              floatingAccountCode: this.model.payerFloatingAccount
                ? this.model.payerFloatingAccount.code
                : null,
              floatingAccountName: this.model.payerFloatingAccount
                ? this.model.payerFloatingAccount.name
                : null,
            },
            receiverInfo: {
              accountCode: this.model.receiverAccount.code,
              accountName: this.model.receiverAccount.name,
              floatingAccountCode: this.model.receiverFloatingAccount
                ? this.model.receiverFloatingAccount.code
                : null,
              floatingAccountName: this.model.receiverFloatingAccount
                ? this.model.receiverFloatingAccount.name
                : null,
            },
          };
          this.createAccount(payload).then(() => {
            this.$emit("finish");
            this.model = {};
            this.$validator.reset();
            this.disabled = false;
          });
        } else {
          // form have errors
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.disabled = false;

        if (this.model.id) this.popupTitle = "CreateChargePettycashsAccount";
        else this.popupTitle = "CreateChargePettycashsAccount";
      }
      this.$validator.reset();
    },
  },
};
</script>
<style></style>
